module.exports = "<div id=\"non-responsive-firm-page-id\">\r\n\t<app-non-responsive-firm></app-non-responsive-firm>\r\n</div>\r\n"